import AtosLogoIcon from './Atos-logo.png';

export const LogoIcon = () => {
  return <img src={AtosLogoIcon} alt="" height="15" />;
};
